import React from "react";
import "./PartnersComp.css";
import corporatePartnerImg from "../../Images/corporatePartnerImg.jpg";
import corporatePartnerImg1 from "../../Images/corporatePartnerImg1.jpg";
import corporatePartnerImg2 from "../../Images/corporatePartnerImg2.webp";
import corporatePartnerImg3 from "../../Images/corporatePartnerImg3.webp";

const CorporatePartner = () => {
  return (
    <div className="collegePartner">
      <div className="partnerCompContainer">
        <div className="partnerComp">
          <img
            src={corporatePartnerImg}
            alt="corporatePartnerImg"
            className="partnerCompImg"
          />
          <div className="partnerCompCover">
            <h2>Corporate Collaborations for Future-Ready Talent</h2>
            <p>
              Career Restorer collaborates with leading companies to deliver
              industry-aligned training, mentorship, and placement—building a
              pipeline of skilled, job-ready talent.
            </p>
            <a href="/joinPartnerForm">
              <button>Join as Partner</button>
            </a>
          </div>
        </div>
        <div className="partnerCompSection2">
          <div className="partnerCompSection2Text">
            <h3>Corporate Collaboration for Career Growth</h3>
            <p>
              Career Restorer’s corporate partnerships are built on shared
              purpose and long-term impact. We work with companies that are
              committed to nurturing talent and shaping the future workforce.
              These collaborations go beyond sponsorship—they involve
              co-creating training programs, offering strategic mentorship, and
              opening doors to employment. By aligning academic learning with
              industry expectations, we help students become confident
              professionals and help companies build a pipeline of skilled,
              job-ready talent.
            </p>
          </div>
          <img src={corporatePartnerImg1} alt="serviceApplicationImg1" />
        </div>
        <div className="partnerCompSection2">
          <img src={corporatePartnerImg2} alt="serviceApplicationImg1" />
          <div className="partnerCompSection2Text">
            <h3>Real-World Exposure Through Internships & Projects</h3>
            <p>
              Our corporate partners provide students with immersive experiences
              through internships, live projects, and shadowing opportunities.
              These engagements allow learners to apply classroom knowledge to
              real business challenges, develop soft skills, and build
              professional networks. Whether it's working on a marketing
              campaign, analyzing financial data, or contributing to HR
              operations, students gain practical insights that accelerate their
              career readiness and boost their employability.
            </p>
          </div>
        </div>
        <div className="partnerCompIntegration">
          <div className="IntegrationText">
            <h2>
              Drive Workforce Readiness Through Strategic Corporate
              Collaboration With Real-World Training, Mentorship, and Career
              Acceleration
            </h2>
          </div>
          <div className="IntegrationOuterBlock">
            <div className="IntegrationBlock">
              <div className="IntegrationCards">
                <h3>1</h3>
                <h4>Industry-Aligned Training</h4>
                <p>
                  Corporates help design and deliver training programs in
                  Banking, Finance, HR, Digital Marketing, and more.
                </p>
              </div>
              <div className="IntegrationCards">
                <h3>3</h3>
                <h4>Internships & Live Projects</h4>
                <p>
                  Students gain hands-on experience through corporate-sponsored
                  internships and project-based learning.
                </p>
              </div>
              <div className="IntegrationCards">
                <h3>5</h3>
                <h4>Mentorship & Career Guidance</h4>
                <p>
                  Professionals from partner companies mentor aspiring
                  candidates, offering insights into industry trends and career
                  paths.
                </p>
              </div>
            </div>
            <div className="IntegrationBlock">
              <div className="IntegrationCards">
                <h3>2</h3>
                <h4>Placement Support</h4>
                <p>
                  Our corporate network actively recruits skilled candidates,
                  creating direct pathways to employment.
                </p>
              </div>
              <div className="IntegrationCards">
                <h3>4</h3>
                <h4>Innovation & Research Collaboration</h4>
                <p>
                  Companies support research initiatives and encourage
                  innovation through joint programs and hackathons.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="partnerCompSection2">
          <div className="partnerCompSection2Text">
            <h3>Mentorship, Placement & Innovation</h3>
            <p>
              Through mentorship programs, corporate leaders guide students on
              career choices, industry trends, and personal development. Our
              placement ecosystem connects graduates with hiring managers across
              sectors, ensuring a smooth transition from education to
              employment. In addition, we collaborate on innovation and research
              initiatives—such as hackathons, joint studies, and product
              development—that encourage students to think creatively and
              contribute meaningfully to the future of work.
            </p>
          </div>
          <img src={corporatePartnerImg3} alt="serviceApplicationImg1" />
        </div>
      </div>
    </div>
  );
};

export default CorporatePartner;
